/**
 * 图片画廊 Tab 切换组件
 */

import React from 'react';
import { Image as ImageIcon } from 'lucide-react';

interface ImageGalleryTabsProps {
  /** 当前激活的 Tab */
  activeTab: 'search' | 'saved';
  /** Tab 切换回调 */
  onTabChange: (tab: 'search' | 'saved') => void;
  /** 搜索结果数量 */
  searchCount: number;
  /** 保存图片数量 */
  savedCount: number;
}

/**
 * 图片画廊 Tab 切换组件
 * 切换搜索缩略图和保存的高清图片
 */
export const ImageGalleryTabs: React.FC<ImageGalleryTabsProps> = ({
  activeTab,
  onTabChange,
  searchCount,
  savedCount,
}) => {
  return (
    <div className="flex items-center gap-2 mb-3">
      {/* 搜索缩略图 Tab */}
      <button
        onClick={() => onTabChange('search')}
        className={`px-3 py-1 text-[11px] rounded-full transition-colors ${
          activeTab === 'search'
            ? 'bg-blue-500/20 text-blue-400'
            : 'bg-white/5 text-gray-500 hover:text-gray-300'
        }`}
      >
        搜索缩略图 ({searchCount})
      </button>

      {/* 高清图片 Tab */}
      <button
        onClick={() => onTabChange('saved')}
        className={`px-3 py-1 text-[11px] rounded-full transition-colors flex items-center gap-1 ${
          activeTab === 'saved'
            ? 'bg-purple-500/20 text-purple-400'
            : 'bg-white/5 text-gray-500 hover:text-gray-300'
        }`}
      >
        <ImageIcon size={12} />
        高清图片 ({savedCount})
      </button>
    </div>
  );
};
